<template>
	<div
		tabindex="-1"
		@keypress.space="startSpacebarUnmute"
		@keyup.space="stopSpacebarUnmute"
	>
		<slot />
	</div>
</template>

<script>
import { isMuted, getIsPublishing } from './data'
import { showAlert, hideAlert } from './MeetingAlert'
import i18n from '@/i18n'

const targetIsMessageInput = ({ target = {} }) => {
	return ['INPUT', 'TEXTAREA'].includes(target.tagName)
}

export default {
	name: 'SpacebarUnmute',
	data() {
		return { alert: null, token: null, isSpacebarMuted: false }
	},
	methods: {
		startSpacebarUnmute(e) {
			if (!getIsPublishing() || targetIsMessageInput(e)) return
			if (this.token || this.alert || !isMuted()) return
			// if we're currently muted, wait 1 second to make sure
			// user is still holding down the spacebar
			this.token = setTimeout(() => {
				// user is still holding spacebar so unmute
				EventBus.$emit('meetingUnmute')
				this.alert = showAlert({
					text: i18n.global.t('meetings_audio_unmute_temp'),
					error: true,
					autoHide: false,
				})
				this.token = null
				this.isSpacebarMuted = true
			}, 1000)
		},

		stopSpacebarUnmute(e) {
			if (targetIsMessageInput(e)) return
			// hide alert if it was visible
			hideAlert(this.alert)
			this.alert = null
			// if we were still waiting for our 1 second, then
			// just clear the timeout and bail
			if (this.token) {
				clearTimeout(this.token)
				this.token = null
				return
			}
			if (isMuted() || !this.isSpacebarMuted) return
			EventBus.$emit('meetingMute')
			this.isSpacebarMuted = false
		},
	},
}
</script>
